/**
 * UX-2B §23 — Employee Mobile Bottom Navigation.
 * NUR fuer role === "employee" (positiver Check im ProtectedRoute-Render,
 * ARR-UX-013). Tablet und Admin erhalten diese Navigation NIEMALS.
 * Nur Mobile (<768px, CSS). Reine Navigation, keine Daten, keine Mutation.
 */
import React from "react";
import { NavLink } from "react-router-dom";
import { Sun, Calendar, Clock, FileText, Repeat } from "lucide-react";
import "./EmployeeMobileNav.css";

const ITEMS = [
  { path: "/mein-bereich",  label: "Heute",    icon: Sun },
  { path: "/schichtplan",   label: "Plan",     icon: Calendar },
  { path: "/zeiterfassung", label: "Stempeln", icon: Clock },
  { path: "/abwesenheiten", label: "Anträge",  icon: FileText },
  { path: "/schichttausch", label: "Tausch",   icon: Repeat },
];

export const EmployeeMobileNav = () => (
  <nav className="emp-mobile-nav" data-testid="employee-mobile-nav" aria-label="Schnellnavigation">
    {ITEMS.map(({ path, label, icon: Icon }) => (
      <NavLink
        key={path}
        to={path}
        className={({ isActive }) => `emp-mobile-nav-item ${isActive ? "is-active" : ""}`}
        data-testid={`emp-mobile-nav-${path.replace("/", "")}`}
      >
        <Icon size={20} aria-hidden="true" />
        <span>{label}</span>
      </NavLink>
    ))}
  </nav>
);

export default EmployeeMobileNav;
